import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayContainer } from '@angular/cdk/overlay';
import { TranslateModule } from '@ngx-translate/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FakeloaderComponent } from './fakeloader';
import { AppOverlayContainer } from './fake-overlay-container';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        // TODO: Create a new generic module - to import generic modules in app.module
        MatSnackBarModule
    ],
    declarations: [FakeloaderComponent],
    exports: [FakeloaderComponent],
    providers: [{
        provide: OverlayContainer,
        useClass: AppOverlayContainer
    }]
})
export class FakeloaderComponentModule {}
